import React from 'react';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';
import { AiFillLike } from 'react-icons/ai';

import useLocalStorage from '../hooks/useLocalStorage';
import useFirestore from '../hooks/useFirestore';
import useCollection from '../hooks/useCollection';

export default function LikeButton({ proposalId }) {
  const [liked, setLiked] = useLocalStorage(`jt-espt-proposal-ids`, []);
  const [sessionId, setSessionId] = useLocalStorage(`jt-espt-sessionId`, '');
  const { addDocument, deleteDocument } = useFirestore('likes');
  const { documents } = useCollection('likes', 'proposalId', proposalId, 'id', sessionId);
  const isLiked = liked.includes(proposalId);

  const handleClick = () => {
    setLiked(prev => {
      if (prev.includes(proposalId)) {
        return prev.filter(id => id !== proposalId);
      } else {
        return [...prev, proposalId];
      }
    });
    if (isLiked && sessionId) {
      return handleDeleteLike();
    } else {
      return handleAddLike();
    }
  };

  const handleDeleteLike = () => {
    if (!!documents) {
      const likeId = Object.keys(documents)[0];
      console.log(likeId);
      deleteDocument(likeId);
    }
  };

  const handleAddLike = () => {
    if (!sessionId) {
      const newSessionId = uuidv4();
      setSessionId(newSessionId);
      return addDocument({ proposalId, id: newSessionId });
    }
    return addDocument({ proposalId, id: sessionId });
  };

  return (
    <Wrapper liked={isLiked}>
      <LikeIcon />
      <StyledSpan>{isLiked ? 'Liked' : 'Like'}</StyledSpan>
    </Wrapper>
  );
}

const Wrapper = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -5.5px;
  padding: 5px 10px;
  background-color: ${({ liked }) => (liked ? '#ee7d84' : '#fff')};
  color: ${({ liked }) => (liked ? '#fbdfdf' : '#ee7d84')};
  border-radius: 2px;
  border: 2px solid #ee7d84;
  cursor: not-allowed;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: ${({ liked }) => (liked ? '#e3777e' : '#fbdfdf')};
  }
`;

const LikeIcon = styled(AiFillLike)`
  width: 15px;
  height: 15px;
  margin-right: 6px;
`;

const StyledSpan = styled.span`
  margin-bottom: -3px;
  font-size: 1rem;
  font-weight: 700;
  font-size: 14px;
`;
